(function ($) {
  window.LayoutSelector = function (container, layoutInputContainer) {
    container = jQuery(container);
    var layoutInput = jQuery(layoutInputContainer).find(":input");
    var context = this;
    var layoutOptionSelector = "[data-layout-name]";

    // BEHAVIOUR

    container.on("click", layoutOptionSelector, handleLayoutSelection);

    // INITIALIZATION

    markSelected(findLayoutOption(layoutInput.val()));

    // EVENT HANDLERS

    function handleLayoutSelection(event) {
      var layoutName = jQuery(this).data("layout-name");
      setLayout(layoutName);
      markUnselected(container.find(layoutOptionSelector));
      markSelected(this);
    }

    // HELPER FUNCTIONS

    function setLayout(layoutName) {
      if (layoutInput.val() !== layoutName) {
        layoutInput.val(layoutName).trigger("change");
      }
    }

    function markSelected(element) {
      jQuery(element).addClass("selected");
    }

    function markUnselected(element) {
      jQuery(element).removeClass("selected");
    }

    function findLayoutOption(layoutName) {
      return container.find('[data-layout-name="' + layoutName + '"]');
    }
  };
})(jQuery);
